import React from "react";
import { observer } from "mobx-react";
import { PublisherCollectingSocietyUpdateStore } from "../../store";
import { PublisherCollectingSocietyUpdateForm } from "./PublisherCollectingSocietyUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PublisherCollectingSocietyUpdateProps = {
  publisherCollectingSocietyUpdateStore: PublisherCollectingSocietyUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PublisherCollectingSocietyUpdate: React.FC<PublisherCollectingSocietyUpdateProps> =
  observer(
    ({
      publisherCollectingSocietyUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={publisherCollectingSocietyUpdateStore.isSaving}
          />
          <PublisherCollectingSocietyUpdateForm
            publisherCollectingSocietyUpdateStore={
              publisherCollectingSocietyUpdateStore
            }
            collectingSocietyError={
              publisherCollectingSocietyUpdateStore.errors.collectingSociety
                ?.message
            }
            onCollectingSocietyChange={(value) => {
              publisherCollectingSocietyUpdateStore.setCollectingSocietyValue(
                value
              );
            }}
            collectingSocietySelectedValue={
              publisherCollectingSocietyUpdateStore.entityValues
                .showCollectingSociety
            }
            onCollectingSocietySelected={(value) => {
              publisherCollectingSocietyUpdateStore.setSelectedCollectingSociety(
                value
              );
            }}
            collectingSocietyOptions={publisherCollectingSocietyUpdateStore.getCollectingSocietyOptions()}
            cmsAccountNumberError={
              publisherCollectingSocietyUpdateStore.errors.cmsAccountNumber
                ?.message
            }
            onCmsAccountNumberChange={(value: string) => {
              publisherCollectingSocietyUpdateStore.setCmsAccountNumberValue(
                value
              );
            }}
            cmsAccountNumber={
              publisherCollectingSocietyUpdateStore.entityValues
                .cmsAccountNumber
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={publisherCollectingSocietyUpdateStore.saveDisabled}
            onSave={() =>
              publisherCollectingSocietyUpdateStore.savePublisherCollectingSociety()
            }
            onCancel={() =>
              publisherCollectingSocietyUpdateStore.cancelPublisherCollectingSociety()
            }
          />
          <ErrorDialog
            open={publisherCollectingSocietyUpdateStore.errorDialogOpened}
            title={publisherCollectingSocietyUpdateStore.errorTitle}
            description={publisherCollectingSocietyUpdateStore.errorDescription}
            onClose={() =>
              publisherCollectingSocietyUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={publisherCollectingSocietyUpdateStore.confirmDialogOpened}
            title={publisherCollectingSocietyUpdateStore.confirmDialogTitle}
            description={
              publisherCollectingSocietyUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              publisherCollectingSocietyUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              publisherCollectingSocietyUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
